import { Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { NotificationService } from './core/services/notification.service';
import { NotificationAlertComponent } from './core/components/notification/notification-alert.component';

interface NavItem {
  label: string;
  path: string;
  icon: string;
}

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, RouterLink, RouterLinkActive, NotificationAlertComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  private readonly notifications = inject(NotificationService);

  /** Live toast stack rendered by the global host. */
  readonly toasts = this.notifications.notification;

  dismissToast(id: string): void {
    this.notifications.startLeaveAnimation(id);
  }

  readonly year = new Date().getFullYear();

  readonly nav: NavItem[] = [
    { label: 'Dashboard', path: '/dashboard', icon: 'dashboard' },
    { label: 'Book', path: '/book', icon: 'event_available' },
    { label: 'Rooms', path: '/rooms', icon: 'meeting_room' },
  ];
}
